import type { ButtonHTMLAttributes } from "react";

import { cn } from "@/lib/utils";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "ghost" | "dark" | "outline";
  size?: "sm" | "md" | "lg" | "icon";
};

export function Button({ className, variant = "primary", size = "md", ...props }: ButtonProps) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-md font-semibold transition duration-200 focus:outline-none focus:ring-2 focus:ring-amazon-orange/50 disabled:pointer-events-none disabled:opacity-50",
        variant === "primary" &&
          "bg-gradient-to-r from-[#087DB5] to-[#073B70] text-white shadow-sm hover:from-[#098dc9] hover:to-[#084582] active:translate-y-px",
        variant === "secondary" && "bg-[#FF8A00] text-white shadow-sm hover:bg-[#E67C00] active:translate-y-px",
        variant === "ghost" && "text-slate-700 hover:bg-slate-100 hover:text-[#087DB5] dark:text-slate-200 dark:hover:bg-white/10 dark:hover:text-[#00B7B0]",
        variant === "dark" && "bg-[#073B70] text-white hover:bg-[#087DB5]",
        variant === "outline" &&
          "border border-slate-300 bg-white text-[#073B70] hover:border-[#00B7B0] hover:bg-slate-50 dark:border-white/10 dark:bg-white/5 dark:text-white dark:hover:border-[#00B7B0]",
        size === "sm" && "h-9 px-3 text-sm rounded-lg",
        size === "md" && "h-11 px-4 text-sm rounded-xl",
        size === "lg" && "h-12 px-5 text-base rounded-xl font-bold",
        size === "icon" && "h-10 w-10 p-0 rounded-lg",
        className
      )}
      {...props}
    />
  );
}
